// @ts-check

export const DEFAULT_SETTINGS = Object.freeze({
  theme: "lumberlandia_lodge",
  sound: true,
  music: true,
  haptics: true,
  showConflicts: true,
  checkAgainstSolution: false,
  autoRemovePeerNotes: true,
  hideCompletedDigits: false,
  highlightMatchingDigits: true,
  showTimer: true,
  reducedMotion: false,
  highContrast: false,
  largeInteractionMode: false,
  screenReaderVerbosity: "normal",
  pauseOnBackground: true,
  companionFrequency: "normal",
});

export const initialState = Object.freeze({
  route: { name: "home", params: {} },
  catalog: null,
  manifest: null,
  activeGame: null,
  completions: [],
  unlocks: [],
  settings: DEFAULT_SETTINGS,
  companionLine: null,
  dialog: null,
  ready: false,
});

export function reducer(state, action) {
  switch (action.type) {
    case "BOOTSTRAP":
      return { ...state, ...action.payload, ready: true };
    case "NAVIGATE":
      return { ...state, route: action.route, dialog: null };
    case "START_GAME":
      return { ...state, activeGame: action.game, dialog: null };
    case "UPDATE_GAME":
      return { ...state, activeGame: action.game };
    case "COMPLETE_GAME":
      return {
        ...state,
        activeGame: action.game,
        completions: [...state.completions, action.record],
        unlocks: state.unlocks.includes(action.record.collection_item_id)
          ? state.unlocks
          : [...state.unlocks, action.record.collection_item_id],
      };
    case "SETTINGS":
      return { ...state, settings: { ...state.settings, ...action.settings } };
    case "COMPANION_LINE":
      return { ...state, companionLine: action.line };
    case "DIALOG":
      return { ...state, dialog: action.dialog };
    case "CLOSE_DIALOG":
      return { ...state, dialog: null };
    case "RESET_STATS":
      return { ...state, completions: [] };
    default:
      return state;
  }
}
